import { render } from "./hyqz.vue?vue&type=template&id=669f0ea2&scoped=true&ts=true"
import script from "./hyqz.vue?vue&type=script&lang=ts"
export * from "./hyqz.vue?vue&type=script&lang=ts"

import "./hyqz.vue?vue&type=style&index=0&id=669f0ea2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669f0ea2"]])

export default __exports__